import { Suggestions } from '@mint-sdk/api-recommendations';
import { atomWithReducer } from 'jotai/utils';

export enum MetadataCollectorActions {
  SET_RECOMMENDATION = 'recommendation',
  RESET_RECOMMENDATION = 'reset-recommendation',

  RESET = 'reset-all',
}

type MetadataCollectorAction =
  | {
      type: MetadataCollectorActions.SET_RECOMMENDATION;
      data: Suggestions.SuggestionResponseType;
    }
  | {
      type:
        | MetadataCollectorActions.RESET
        | MetadataCollectorActions.RESET_RECOMMENDATION;
    };

type AiMetadata = {
  recommendation: {
    suggestion: Suggestions.SuggestionResponseType | undefined;
  };
};

const initialMetadataState = {
  recommendation: {
    suggestion: undefined,
  } as AiMetadata['recommendation'],
};

const metadataCollectorReducer = (
  prev: AiMetadata,
  action: MetadataCollectorAction,
) => {
  switch (action.type) {
    case MetadataCollectorActions.SET_RECOMMENDATION: {
      return {
        ...prev,
        recommendation: {
          suggestion: action.data,
        },
      };
    }

    case MetadataCollectorActions.RESET_RECOMMENDATION: {
      return {
        ...prev,
        recommendation: initialMetadataState.recommendation,
      };
    }

    case MetadataCollectorActions.RESET: {
      return initialMetadataState;
    }

    default:
      throw new Error('Unknown action type');
  }
};

export const agenticMetadataAtom = atomWithReducer(
  initialMetadataState,
  metadataCollectorReducer,
);
